import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { getStatusColor } from '../../utils/helpers';

const Header = ({ connectionStatus, isMobile }) => {
    const { raikuMode, theme, toggleRaikuMode } = useTheme();

    return (
        <header style={{
            backgroundColor: theme.bg,
            borderRadius: '5px',
            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
            textTransform: 'uppercase',
            width: '100%',
            transition: 'background-color 0.4s ease',
            marginBottom: isMobile ? '24px' : '34px',
            animation: 'fadeIn 0.5s ease-in-out'
        }}>
            <h1 style={{
                animation: 'bubbleAppear 1s ease-in-out',
                border: `5px solid ${theme.border}`,
                borderRadius: '5px',
                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                color: theme.accent,
                fontWeight: 'bolder',
                padding: isMobile ? '17px' : '26px',
                margin: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: isMobile ? '12px' : '17px',
                fontSize: isMobile ? '30px' : '40px',
                position: 'relative',
                transition: 'color 0.4s ease, border-color 0.4s ease'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    Raiku Simulator
                    <span style={{
                        height: isMobile ? '12px' : '15px',
                        width: isMobile ? '12px' : '15px',
                        backgroundColor: getStatusColor(connectionStatus),
                        borderRadius: '50%',
                        display: 'inline-block',
                        transition: 'background-color 0.3s ease'
                    }}></span>
                </div>
                <button
                    onClick={(e) => { e.stopPropagation(); toggleRaikuMode(); }}
                    style={{
                        position: 'absolute',
                        right: isMobile ? '12px' : '26px',
                        padding: isMobile ? '6px 10px' : '8px 16px',
                        borderRadius: '5px',
                        border: `2px solid ${theme.accent}`,
                        backgroundColor: raikuMode ? '#c0fe38' : 'transparent',
                        color: raikuMode ? '#050505' : theme.accent,
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        cursor: 'pointer',
                        textTransform: 'uppercase',
                        fontSize: isMobile ? '10px' : '14px',
                        transition: 'all 0.3s ease',
                        whiteSpace: 'nowrap',
                        zIndex: 5
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = raikuMode ? '#a8e020' : theme.accent;
                        e.target.style.color = raikuMode ? '#050505' : theme.bg;
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = raikuMode ? '#c0fe38' : 'transparent';
                        e.target.style.color = raikuMode ? '#050505' : theme.accent;
                    }}
                >
                    ⚡ Raiku Mode
                </button>
            </h1>
        </header>
    );
};

export default Header;
